import { render, staticRenderFns } from "./InfoBadge.vue?vue&type=template&id=d8a8984e&scoped=true"
import script from "./InfoBadge.vue?vue&type=script&lang=js"
export * from "./InfoBadge.vue?vue&type=script&lang=js"
import style0 from "./InfoBadge.vue?vue&type=style&index=0&id=d8a8984e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a8984e",
  null
  
)

export default component.exports